





































import { computed, defineComponent, ref } from "@vue/composition-api";
import { CreditCardAssignment } from "@scrile/api-provider/dist/api/CreditCardAssignmentsProvider";
import { RecurringBillingSchedule } from "@scrile/api-provider/dist/api/RecurringBillingScheduleProvider";
import { Subscription } from "@scrile/api-provider/dist/api/SubscriptionProvider";
import config from "@/config";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseImage from "@/components/BaseImage";
import BasePage from "@/components/BasePage";
import ComplianceContactsInfo from "@/components/ComplianceContactsInfo";
import EmptyContent from "@/components/EmptyContent";
import InfiniteScroll from "@/components/InfiniteScroll";
import PageTitle from "@/components/PageTitle";
import CancelConfirm from "../CancelConfirm";
import SubscriptionItemView from "../SubscriptionItem";

export default defineComponent({
  name: "PageManageRecurringView",
  components: {
    ComplianceContactsInfo,
    CancelConfirm,
    InfiniteScroll,
    BasePage,
    PageTitle,
    BaseConfirm,
    EmptyContent,
    BaseImage,
    BaseButton,
  },
  props: {
    loading: { type: Boolean, required: true },
    canceling: { type: Boolean, required: true },
    enableScroll: { type: Boolean, required: true },
    creditCard: { type: Object as () => CreditCardAssignment | null },
    list: { type: Array as () => Subscription[], required: true },
  },
  setup(_, { emit }) {
    const subscriptionItemView = SubscriptionItemView;
    const cancelRecurring = ref<RecurringBillingSchedule | null>(null);

    const cancelTitle = ref("");

    const cancelDescription = ref("");

    const cancelCb = ref(() => {});

    const cancelShowConfirm = computed(() => !!cancelRecurring.value);

    const onCancel = (
      {
        recurring,
        title,
        description,
      }: {
        recurring: RecurringBillingSchedule;
        title: string;
        description: string;
      },
      cb: () => void
    ) => {
      cancelRecurring.value = recurring;
      cancelDescription.value = description;
      cancelTitle.value = title;
      cancelCb.value = () => {
        cb();
        cancelRecurring.value = null;
        cancelDescription.value = "";
        cancelTitle.value = "";
        cancelCb.value = () => {};
      };
    };

    const onConfirmInput = (status: boolean) => {
      if (status) emit("cancel", cancelRecurring.value, () => cancelCb.value());
      else cancelCb.value();
    };

    return {
      config,
      cancelTitle,
      cancelDescription,
      cancelShowConfirm,
      onCancel,
      onConfirmInput,
      subscriptionItemView,
    };
  },
});
